<script>
  import UserIcon from './UserIcon.svelte';
  import UserDialog from './UserDialog.svelte';

  export let user = "";

  let userIcon;
  let userDialog;

  function onIconClick(e) {
    if (wasBlurred) return;

    if (!userDialog.isVisible()) {
      var rect = userIcon.getBoundingClientRect();
      userDialog.show({ x: rect.left, y: rect.bottom }, user || "");
      dialogShowing = true;
    } else {
      userDialog.hide();
    }
  }

  let dialogShowing = false;
  let wasBlurred = false;
  function onDialogBlur() {
    wasBlurred = true;
    userDialog.hide();
    dialogShowing = false;
    // Trick to make click on user icon hide the dialog when dialog is already showing.
    // Because the blur (lost focus) event fires before the user icon click event.
    setTimeout(() => (wasBlurred = false), 100); 
  }
</script>

<div>
  <UserIcon bind:this={userIcon} hoverable bind:pressed={dialogShowing} on:click={(e) => onIconClick(e)} />
</div>
<UserDialog bind:this={userDialog} on:blur={() => onDialogBlur()} />

<style>
  div {
    cursor: pointer;
  }
</style>